import Resource from '@/api/resources/Resource'

class PetitionerDepartmentConfigurationServices extends Resource {
    async paginator(filterModel, params) {
        const response = await this.axios.put(`/configuration/petitionerDepartments`, filterModel, { params })
        return response.data
    }
    async createPetitionerDepartment(petitionerDepartmentCreateRequest) {
        const response = await this.axios.post(`/configuration/petitionerDepartments`, petitionerDepartmentCreateRequest)
        return response.data
    }
    async deletePetitionerDepartment(petitionerDepartmentId) {
        const response = await this.axios.delete(`/configuration/petitionerDepartments/${petitionerDepartmentId}`)
        return response.data
    }
}

export default new PetitionerDepartmentConfigurationServices()
